'use strict';

import { UAParser } from 'ua-parser-js';

const DEFAULT_LANGUAGE = 'en';

/**
 * Resolve the player's language from the browser's language setting.
 *
 * Kept byte-for-byte in step with the SDK's copy (`apps/sdk/src/models/Environment.js`), which is
 * what games actually read as `g8sdk.environment.language`. The plugin's own copy has no consumer
 * today beyond attribute targeting, but the two must not drift apart.
 *
 * Only the primary subtag is exposed ("en-US" -> "en").
 *
 * @param {Navigator} [nav] navigator to read from; defaults to the global one.
 * @return {string} lowercase primary subtag, or 'en' when the browser offers nothing usable.
 */
export function resolveLanguage(nav = typeof navigator === 'undefined' ? undefined : navigator) {
  const tag = nav?.languages?.[0] || nav?.language;
  if (typeof tag !== 'string') return DEFAULT_LANGUAGE;

  return tag.trim().split('-')[0].toLowerCase() || DEFAULT_LANGUAGE;
}

/**
 * Environment
 */
class Environment {
  /**
   * Constructor of Environment.
   * @return {*}
   */
  constructor() {
    const ua = new UAParser().getResult();

    // public variables
    this.language = resolveLanguage();
    this.device = ua.device.type;
    this.platform = this._parsePlatform(this.device);
  }

  _parsePlatform(device) {
    switch (device) {
      case 'mobile':
      case 'tablet':
      case 'smarttv':
        return 'MOBILE_WEB';
      default:
        return 'WEB';
    }
  }
}
export default Environment;
